// removed by extract-text-webpack-plugin
module.exports = {"container":"page-not-found__container___1D2Jx","title":"page-not-found__title___3c5jS"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/page-not-found.scss
// module id = 1348
// module chunks = 0